import Fashion from './Fashion';

export default Fashion;